import { ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { IntegrationParam } from '../../models/integration-param.model';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Observable, of } from 'rxjs';
import { ModalParamComponent } from '../modal-param/modal-param.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IntegrationsService } from '../../services/integrations.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-params-list',
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule
  ],
  templateUrl: './params-list.component.html',
  styleUrl: './params-list.component.css'
})
export class ParamsListComponent implements OnInit, OnDestroy {

  public dialogRef?: MatDialogRef<ModalParamComponent>;
  readonly dialog = inject(MatDialog);

  @Input() params: IntegrationParam[] = [];

  public params$: Observable<IntegrationParam[]> = of(this.params);

  public dataSource = new MatTableDataSource<any>(this.params);

  public displayedColumns: string[] = [
    'name',
    'type',
    'val',
    'action'
  ];

  private sss: any;

  constructor(
    public integrationsService: IntegrationsService,
    public cd: ChangeDetectorRef
  ) { }

  ngOnDestroy(): void {
    this.sss.unsubscribe();
  }
  ngOnInit(): void {
    console.log("ngOnInit", this.params);

    this.dataSource = new MatTableDataSource<any>(this.params);

    this.sss = this.integrationsService.integrationChanged().subscribe({
      next: (data: any) => {
        console.log("data", data);
        this.params = data.params;
        this.dataSource = new MatTableDataSource<any>(this.params);
        this.cd.detectChanges();
      }
    });
  }

  edit(element: IntegrationParam) {
    console.log(element);
    this.openDialog(element);
  }


  /*openModal(element: IntegrationParam) {
    console.log(element);
  }*/

  deleteParam(param: IntegrationParam) {
    this.integrationsService.deleteParam(param.id)
      .subscribe({
        next: (response: any) => {
          console.log("deleteParam", response);
          this.fetchIntegration();
        }
      });
  }

  fetchIntegration() {
    this.integrationsService.fetchIntegration(this.integrationsService.currentIntegration.id)
      .subscribe({
        next: (response: any) => {
          console.log("fetchIntegration", response);
          this.integrationsService.setCurrentIntegration(response);// = response;
          //this.integrationsService.fetchIntegration(this.integrationsService.currentIntegration.id);
        }
      });
  }
  remove(element: IntegrationParam) {
    console.log(element);
    if (confirm("NA pewno usunąć " + element.name + "?")) {
      this.deleteParam(element);
    }
  }

  openDialog(param: IntegrationParam): void {
    console.log("openDialog", param);
    this.integrationsService.currentParam = param;
    this.dialogRef = this.dialog.open(ModalParamComponent, {
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe(result => {
      this.cd.detectChanges();
    });
  }

  addParam() {
    console.log("add param");
    this.openDialog(new IntegrationParam(0));
  }

}
